import React from 'react';
import { Link } from "@tanstack/react-router";
import styles from './BreadCrumbs.module.scss';
import Divider from '../../images/icons/breadcrumb-divider.svg';

const BreadCrumbs = ({ crumbs }) => {
  return (
    <nav aria-label="breadcrumb" className={styles.container}>
      {crumbs.map((crumb, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <span
            key={i}
            className={`${styles.breadcrumb} ${isLast ? styles.active : ''}`}
            aria-current={isLast ? 'page' : undefined}
          >
            {isLast ? crumb.title : <Link to={crumb.url}>{crumb.title}</Link>}
          </span>
        );
      })}
    </nav>
  );
};

export default BreadCrumbs;
